module.exports = __webpack_public_path__ + "static/p4-9fd30c9d8930679bcb46d9060cf49119.jpg";